import { Fragment } from "react";

export const SKTToggle = ({ when, children }) => {
  if (!!when) return <Fragment>{children}</Fragment>;
  return "";
};
